import { getCode } from '@core/utils/codes'
import Form from '@admin/components/form'
import TimesField from '../timesfield'
import PropTypes from 'prop-types'
import React from 'react'

class TimeBlock extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    mode: PropTypes.string,
    timeblock: PropTypes.object,
    onDone: PropTypes.func
  }

  static defaultProps = {
    timeblock: {}
  }

  state = {
    config: null
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    const { timeblock } = this.props
    this.setState({
      config: {
        ...this._getDefault(),
        ...timeblock
      }
    })
  }

  _getDefault() {
    return {
      code: getCode(10)
    }
  }

  _getForm() {
    const { config } = this.state
    const { mode } = this.props
    return {
      title: 't(Time Block)',
      cancelSvg: 'chevron_left',
      onCancel: this._handleBack,
      onChange: this._handleChange,
      onSuccess: this._handleDone,
      saveText: mode === 'new' ? 't(Add)' : 't(Update)',
      sections: [
        {
          fields: [
            { name: 'code', type: 'hidden', value: config.code },
            { label: 't(Name)', name: 'name', type: 'textfield', required: true, placeholder: 'Enter a name', defaultValue: config.name },
            { label: 't(Days)', name: 'days', type: 'checkboxgroup', options: [
              { value: 0, text: 't(Sunday)' },
              { value: 1, text: 't(Monday)' },
              { value: 2, text: 't(Tuesday)' },
              { value: 3, text: 't(Wednesday)' },
              { value: 4, text: 't(Thursday)' },
              { value: 5, text: 't(Friday)' },
              { value: 6, text: 't(Saturday)' }
            ], defaultValue: config.days },
            { label: 't(Times)', name: 'times', type: TimesField, required: true, defaultValue: config.times }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.context.form.pop()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone() {
    const { config } = this.state
    this.props.onDone(config)
    this.context.form.pop()
  }

}

export default TimeBlock
